import { pageconfigurationsApi } from 'app/src/services/welfareportal/'
import { DefaultBodyType, http, HttpResponse } from 'msw'
import { apiBaseUrl } from './commonconfig'

const getUserAccountPageConfig = http.get<object, DefaultBodyType, pageconfigurationsApi.Page>(
  apiBaseUrl + '/:templateId/pages/useraccountpage',
  () => {
    return HttpResponse.json([
      {
        id: 'useraccountpage',
        sections: [
          {
            renderingMode: 'native',
            sectionName: 'InformativeSection',
          },
          {
            renderingMode: 'native',
            sectionName: 'WalletOverviewSection',
          },
          {
            renderingMode: 'native',
            sectionName: 'PrizeSection',
          },
          {
            renderingMode: 'native',
            sectionName: 'OrderListSection',
          },
        ],
      },
    ])
  },
)

export const useraccountpageConfigHandlers = [getUserAccountPageConfig]
